import { render, staticRenderFns } from "./EternityMilestonesTab.vue?vue&type=template&id=3165bf56&scoped=true&"
import script from "./EternityMilestonesTab.vue?vue&type=script&lang=js&"
export * from "./EternityMilestonesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165bf56",
  null
  
)

export default component.exports